"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TargetGraphBuilder", {
    enumerable: true,
    get: function() {
        return TargetGraphBuilder;
    }
});
const _targetId = require("./targetId.js");
const _prioritize = require("./prioritize.js");
const _detectCycles = require("./detectCycles.js");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class TargetGraphBuilder {
    addTarget(target) {
        this.targets.set(target.id, target);
        this.addDependency((0, _targetId.getStartTargetId)(), target.id);
        return target;
    }
    addDependency(dependency, dependent) {
        if (this.targets.has(dependent)) {
            const target = this.targets.get(dependent);
            if (!target.dependencies.includes(dependency)) {
                target.dependencies.push(dependency);
            }
        }
        if (this.targets.has(dependency)) {
            const target = this.targets.get(dependency);
            if (!target.dependents.includes(dependent)) {
                target.dependents.push(dependent);
            }
        }
    }
    /**
   * Builds a target graph for given tasks and packages
   */ build() {
        // Ensure we do not have cycles in the subgraph
        const cycleInfo = (0, _detectCycles.detectCycles)(this.targets);
        if (cycleInfo.hasCycle) {
            throw new Error("Cycles detected in the target graph: " + cycleInfo.cycle.concat(cycleInfo.cycle[0]).join(" -> "));
        }
        // The full graph might produce a different aggregated priority value for a target
        (0, _prioritize.prioritize)(this.targets);
        return {
            targets: this.targets
        };
    }
    subgraph(entriesTargetIds) {
        const subgraphBuilder = new TargetGraphBuilder();
        const visited = new Set();
        const queue = [];
        for (const targetId of entriesTargetIds){
            if (this.targets.has(targetId)) {
                const target = this.targets.get(targetId);
                subgraphBuilder.addTarget({
                    ...target,
                    dependencies: [],
                    dependents: []
                });
                queue.push(targetId);
            }
        }
        while(queue.length > 0){
            const targetId = queue.shift();
            if (visited.has(targetId)) {
                continue;
            }
            visited.add(targetId);
            const target = this.targets.get(targetId);
            if (!target) {
                throw new Error("Subgraph builder failed - target not found: " + targetId);
            }
            for (const dependency of target.dependencies){
                if (dependency !== (0, _targetId.getStartTargetId)()) {
                    if (!subgraphBuilder.targets.has(dependency)) {
                        subgraphBuilder.addTarget({
                            ...this.targets.get(dependency),
                            dependencies: [],
                            dependents: []
                        });
                    }
                    subgraphBuilder.addDependency(dependency, targetId);
                }
                if (!visited.has(dependency)) {
                    queue.push(dependency);
                }
            }
        }
        return subgraphBuilder.build();
    }
    /**
   * Initializes the builder with package infos
   */ constructor(){
        /** A map of targets - used internally for looking up generated targets from the target configurations */ _define_property(this, "targets", new Map());
        const startId = (0, _targetId.getStartTargetId)();
        this.targets.set(startId, {
            id: startId,
            task: startId,
            cwd: "",
            label: "Start",
            hidden: true,
            dependencies: [],
            dependents: [],
            depSpecs: [],
            weight: 1,
            priority: 0
        });
    }
}
